import Api from "../../utils/Api.jsx";
import ApiceFadeIn from "../../lib_react_frontend/componentes/ApiceFadeIn.jsx";
import Button from "../componentes/Button.jsx";
import Cookies from "../../lib_react_frontend/utils/Cookies.jsx";
import Input from "../componentes/Input.jsx";
import React from "react";
import Row from "../componentes/Row.jsx";
import { connect } from "react-redux";
import constants from "../../constants.js";
import { toastr } from "react-redux-toastr";
import uuid from "uuid/v1";

import SideImagem from "../../imagens/ApiceFechamento.png";
import TelaLogout from "../componentes/TelaLogout.jsx";
import { Link } from "react-router-dom";

/**
 * Tela de login padrão utilizada nos sistemas, é possível passar uma cor
 * para ele de forma a customizar ela.
 */
class Login extends React.Component {
  constructor() {
    super();
    this.state = {
      login: "",
      senha: "",
      uuid: uuid(),
      tipoSenha: true,
    };

    // Padrão do LTE:
    document.body.className = "hold-transition login-page";

    this.setInputLoginRef = (element) => {
      this.inputLoginRef = element;

    };
    this.setInputSenhaRef = (element) => {
      this.inputSenhaRef = element;
    };


  }


  /**
   * Trata as validações antes de realizar o login.
   */
  realizarValidacoes() {
    if (!this.state.login) {
      this.inputLogin.focus();
      toastr.error("Atenção!", "Informe o login!");
      return;
    }
    return true;
  }

  /**
   * Realiza o login no backend.
   */
  async realizarLogin() {
    if (!this.realizarValidacoes()) {
      return;
    }

    try {
      const ret = await Api.login(
        this.state.login.toUpperCase(),
        this.state.senha
      );

      if (ret.status) {
        // Sucesso no login!
        const dezAnos = new Date(
          new Date().getTime() + 1000 * 60 * 60 * 24 * 365 * 10
        );
        Cookies.set(global.app.cookie, ret.dados.token, dezAnos);
        this.props.history.push("/app");
      } else {
        toastr.error("Atenção!", ret.erro.error_message);
      }
    } catch (ex) {
      // console.log(ex);
      toastr.error(
        "Erro!",
        "Rode o atualizador pelo console, provavelmente há um erro!"
      );
    }
  }

  renderBody() {
    return (
      < div className="login-box-body" >
        <div className="stripe" />
        <div>
          {/* Login: */}
          <div className="form-group has-feedback " style={{ position: "relative", width: "100%" }}>
            <Input
              placeholder="Digite seu login"
              value={this.state.login}
              ref={this.setInputLoginRef}
              onKeyEnter={() => this.inputSenhaRef.focus()}
              onChange={(e) => this.setState({ login: e.target.value })}
              name={this.state.uuid}
              autoComplete
              style={{
                height: '50px',
                fontSize: '18px',
                padding: '10px',
              }}
            />
            <i className="fa fa-sign-in form-control-feedback"
              style={{
                position: "absolute",
                right: "15px",
                top: "50%",
                transform: "translateY(-50%)",
                fontSize: "18px",
              }} />
          </div>

          {/* Senha: */}
          <div className="form-group has-feedback" style={{ position: "relative", width: "100%" }}>
            <Input
              placeholder="Digite sua senha"
              value={this.state.senha}
              ref={this.setInputSenhaRef}
              onChange={(e) => this.setState({ senha: e.target.value })}
              onKeyEnter={this.realizarLogin.bind(this)}
              uppercase={false}
              type={this.state.tipoSenha ? 'password' : 'input'}
              autoComplete
              style={{
                height: '70%',
                fontSize: '18px',
                padding: '10px',
              }} />
            <i
              className={`fa ${this.state.tipoSenha ? "fa-eye" : "fa-eye-slash"}`}
              onClick={() =>
                this.state.tipoSenha
                  ? this.setState({ tipoSenha: false })
                  : this.setState({ tipoSenha: true })
              }
              style={{
                position: "absolute",
                right: "25px",
                top: "50%",
                transform: "translateY(-50%)",
                fontSize: "18px",
                cursor: "pointer",
              }}
            />
          </div>
          <div
            id=""
            style={{ textAlign: "center", fontSize: '20px', marginTop: "10px" }}
            className="login-text"
          >
            <b>
              <a
                href=""
                onClick={(e) => {
                  e.preventDefault();
                  this.props.history.push("/esqueceu-senha");
                }}
              >
                Esqueceu a Senha?
              </a>
            </b>
          </div>

          {/* Linha de realizar login: */}
          <Row>
            <div className="col-sm-2 col-sm-offset-4 text-center"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "20px",
                width: "35%",
              }}>
              <Button
                icon="fa-sign-in"
                label="Entrar"
                className="btn-primary"
                onClick={this.realizarLogin.bind(this)}
                style={{
                  width: '150px',
                  height: '45px',
                  fontSize: '18px',
                  padding: '10px',
                }}
              />
            </div>
          </Row>
        </div>
      </div >
    )
  }

  render() {

    return (
      <div>
        <TelaLogout
          renderBody={this.renderBody.bind(this)}
          ref={e => this.login = e}
          focusFieldRef={() => this.inputLoginRef.focus()}
        />
      </div>


    );
  }
}

export default connect(
  (state) => ({
    socket: state.socket,
  }),
  (dispatch) => ({
    dispatch,
  })
)(Login);





// WEBPACK FOOTER //
// ./src/lib_react_adminlte/main/Login.jsx